import {
  FETCH_IWO_STATUS_REQUEST,
  FETCH_IWO_STATUS_SUCCESS,
  FETCH_IWO_STATUS_FAILURE,
  UPDATE_IWO_STATUS_REQUEST,
  UPDATE_IWO_STATUS_SUCCESS,
  UPDATE_IWO_STATUS_FAILURE,
} from "../constants/IwoStatusConstants";

const initialState = {
  loading: false,
  data: [],
  error: null,

  // update
  updating: false,
  updatingIwoNo: null,
  updateError: null,
  updateMessage: null,
};

const IwoStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_IWO_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_IWO_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };

    case FETCH_IWO_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_IWO_STATUS_REQUEST:
      return {
        ...state,
        updating: true,
        updatingIwoNo: action.payload,
        updateError: null,
        updateMessage: null,
      };

    case UPDATE_IWO_STATUS_SUCCESS:
      return {
        ...state,
        updating: false,
        updatingIwoNo: null,
        updateError: null,
        updateMessage: action.payload?.message || "Record updated successfully.",
        // keep the grid in sync until the reload finishes
        data: state.data.map((item) =>
          item.IwoNo === action.payload.iwoNo
            ? { ...item, IwoStatusCode: action.payload.status }
            : item
        ),
      };

    case UPDATE_IWO_STATUS_FAILURE:
      return {
        ...state,
        updating: false,
        updatingIwoNo: null,
        updateError: action.payload,
      };

    default:
      return state;
  }
};

export default IwoStatusReducer;
